import { TEAM_ROUTE_ID } from './common';
import TeamManagement from './components/TeamManagement';

export default {
    [TEAM_ROUTE_ID]: () => <TeamManagement />
};
